import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const DRAG_RESIZE_HANDLE_CLASS_NAME = 'DragResizeHandle';
export const DRAG_RESIZE_HANDLE_CLASS_SLOTS = ['root', 'ellipsis'] as const;

export type DragResizeHandleClassSlot =
	(typeof DRAG_RESIZE_HANDLE_CLASS_SLOTS)[number];

export interface DragResizeHandleClasses {
	root: string;
	ellipsis: string;

	dragging: string;
	bottom: string;
	left: string;
	right: string;
	top: string;
}

export type DragResizeHandleClassKey = keyof DragResizeHandleClasses;

export const getDragResizeHandleUtilityClass = (slot: string) =>
	generateUtilityClass(DRAG_RESIZE_HANDLE_CLASS_NAME, slot);

export const dragResizeHandleClasses: DragResizeHandleClasses =
	generateUtilityClasses(DRAG_RESIZE_HANDLE_CLASS_NAME, [
		'root',
		'dragging',
		'ellipsis',
		'left',
		'right',
		'top',
		'bottom',
	]);

export default dragResizeHandleClasses;
